export interface Payment {
  token: string;
  amount: number;
}

export const paymentIdle = 'idle';
export const paymentProcessing = 'processing';
export const paymentCompleted = 'completed';
export const paymentError = 'error';
